import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { assign, findIndex, forEach, omit, remove } from 'lodash'
import _ from 'lodash-es'
import * as helpers from '../helpers'

const initialState: any = []
const locationsSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    addLocation: (state, action: PayloadAction<any>) => {
      state.push(action.payload)
    },
    insertLocation: (state, action: PayloadAction<any>) => {
      state.splice(state.length - 1, 0, action.payload)   
    },
    removeLocation: (state, action: PayloadAction<any>) => {   
      remove(state, { id: action.payload })
    },
    updateLocation: (state, action: PayloadAction<any>) => {
      const index = findIndex(state, (location: any) => parseInt(location.id, 10) === parseInt(action.payload.id, 10))
      if (index !== -1) {
        if (action.payload.locationAttrs.is_payer) {
          forEach(state, (location) => {
            assign(location, { is_payer: false })
          })
        }
        if (!action.payload.locationAttrs.is_store) {
          state[index].is_store = false
        }
        state[index] = assign({}, state[index], action.payload.locationAttrs)
      }
    },
    updateLazyAddressLocationNewBooking: (state, action: PayloadAction<any>) => {
      const index = _.findIndex(state, (location: any) => parseInt(location.id, 10) === parseInt(action.payload.id, 10))
      if (index !== -1) {
        state[index] = {
          ...state[index],
          lazyAddress: {
            ...state[index].lazyAddress,
            [action.payload.id]: action.payload.lazyAddressError
          }
        }
      }
    },
    setLocation: (state, action: PayloadAction<any>) => {
      const locations = [...state]
      helpers.removeBlurMarker(locations)
      return action.payload
    },
    setLocationsWithoutAttrs: (state, action: PayloadAction<any>) => {
      const newLocations = (state || []).map((item: any) => ({ ...item }))
      forEach(newLocations, (location, index) => {
        assign(location, omit(action.payload.locations[index], action.payload.locationAttrs))
      })
      return newLocations
    },
    removeBlurMarker: (state) => {
      const locations = [...state]
      return helpers.removeBlurMarker(locations)
    },
    createLocationsEdit: (state, action: PayloadAction<any>) => action.payload,
    backupLocations: (state, action: PayloadAction<any>) => action.payload.locations,
  },
  extraReducers: () => {},
})
export const locationsActionsCreator = locationsSlice.actions

export default locationsSlice
